import { loadApiToFormData } from 'designer/component/action/Design'

export const fetchData = async ({ data, designContext }) => {
  let { formData, allParams } = data
  const { jsonForm } = designContext
  formData = await loadApiToFormData(jsonForm, formData, {
    ...data,
    urlParams: allParams,
  })
  return {
    status: 200,
    message: 'Success fetch',
    data: formData,
  }
}
